import api from '../services/api';
import { IGuide } from '../shared/interfaces';

interface IResponseGetGuides {
  data: IGuide[];
  count: number;
}
export const getGuides = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetGuides> => {
  const response = await api.post('/guides/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postGuide = async (payload: any): Promise<IGuide> => {
  const response = await api.post(`/guides`, payload);
  return response.data;
};

export const patchGuide = async (
  id: string | undefined,
  payload: any,
): Promise<IGuide> => {
  if (!id) {
    throw new Error('ID da guia não fornecido.');
  }
  const response = await api.patch(`/guides/${id}`, payload);
  return response.data;
};
